export default __webpack_public_path__ + "static/media/cladding4.ef1fef2b.jpeg";